import { useEffect } from 'react';
import { css, cx } from 'linaria';
import { CrossIcon } from 'components/icons/CrossIcon';
import { ArchiveIcon } from 'components/icons/ArchiveIcon';
import { AddIcon } from 'components/icons/AddIcon';
import { DeleteIcon } from 'components/icons/DeleteIcon';
import { FavoriteIcon } from 'components/icons/FavoriteIcon';
import { FavoriteFilledIcon } from 'components/icons/FavoriteFilledIcon';
import { TagIcon } from 'components/icons/TagIcon';
import { breakpointMediumHandset } from 'common/constants';
import { bottomTooltip } from 'components/tooltip/tooltip';
import { Trans, useTranslation } from 'next-i18next';
import Mousetrap from 'mousetrap';
const bulkStyle = "b1xsx9mu";
const bulkIconActions = "b172fsd5";
const navIconStyle = "nio91go";
const closeLabelStyle = "c1dmz8tx";

const CloseLabel = ({
  children
}) => <span className={closeLabelStyle}>{children}</span>;

const buttonStyle = "b1vi9mhm";

const CloseButton = ({
  onClick
}) => {
  return <button className={`${buttonStyle} cancel-button`} onClick={onClick} data-cy="bulk-close">
      <CrossIcon className={navIconStyle} />
      <CloseLabel>
        <Trans i18nKey="nav:cancel">Cancel</Trans>
      </CloseLabel>
    </button>;
};

const bulkContainerStyle = "bn8myry";

function GlobalNavBulkEdit({
  onClose,
  batchFavorite,
  batchStatus,
  tagAction,
  favoriteAction,
  archiveAction,
  deleteAction,
  clearBulkItems,
  bulkItemsCount
}) {
  const {
    t
  } = useTranslation();
  const shouldFavorite = batchFavorite === 'favorite';
  const shouldArchive = batchStatus === 'archive';
  const clearAction = bulkItemsCount >= 1 ? clearBulkItems : onClose;
  const clearCopy = bulkItemsCount >= 1 ? t('nav:clear-copy', 'Clear') : t('nav:cancel-copy', 'Cancel');
  useEffect(() => {
    Mousetrap.bind('esc', clearAction);
    return () => Mousetrap.unbind('esc');
  }, [clearAction]);
  return <div className={bulkStyle}>
      <div className={bulkContainerStyle}>
        <div className="bulk-container">
          <div className="bulk-actions">
            <button aria-label={t('nav:tag', 'Tag')} data-tooltip={t('nav:tag', 'Tag')} data-cy="bulk-tag" className={cx(buttonStyle, bottomTooltip)} onClick={tagAction}>
              <TagIcon className={bulkIconActions} />
            </button>

            <button aria-label={shouldFavorite ? t('nav:favorite', 'Favorite') : t('nav:unfavorite', 'Unfavorite')} data-tooltip={shouldFavorite ? t('nav:favorite', 'Favorite') : t('nav:unfavorite', 'Unfavorite')} data-cy="bulk-favorite" className={cx(buttonStyle, bottomTooltip)} onClick={favoriteAction}>
              {shouldFavorite ? <FavoriteIcon className={bulkIconActions} /> : <FavoriteFilledIcon className={bulkIconActions} />}
            </button>

            <button aria-label={shouldArchive ? t('nav:archive-tooltip', 'Archive') : t('nav:add-tooltip', 'Add')} data-tooltip={shouldArchive ? t('nav:archive-tooltip', 'Archive') : t('nav:add-tooltip', 'Add')} data-cy="bulk-archive" className={cx(buttonStyle, bottomTooltip)} onClick={archiveAction}>
              {shouldArchive ? <ArchiveIcon className={bulkIconActions} /> : <AddIcon className={bulkIconActions} />}
            </button>

            <button aria-label={t('nav:delete', 'Delete')} data-tooltip={t('nav:delete', 'Delete')} data-cy="bulk-delete" className={cx(buttonStyle, bottomTooltip)} onClick={deleteAction}>
              <DeleteIcon className={bulkIconActions} />
            </button>

            <div className="labelText">
              {bulkItemsCount ? `${bulkItemsCount} item${bulkItemsCount > 1 ? 's' : ''}` // needs additional translation help
            : <Trans i18nKey="nav:select-items">Select Items</Trans>}
            </div>
          </div>
        </div>
        <button className="bulk-cancel" onClick={clearAction} data-cy="clear-button">
          {clearCopy}
        </button>
        {onClose ? <CloseButton onClick={onClose} data-cy="add-close" /> : null}
      </div>
    </div>;
}

export default GlobalNavBulkEdit;

require("./global-nav-bulk-edit.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./global-nav-bulk-edit.js");